declare namespace $ {

	type $mol_text__text_shm_tests_release_1 = $mol_type_enforce<
		ReturnType< $shm_tests_release['project_info'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_tests_release_2 = $mol_type_enforce<
		ReturnType< $shm_tests_release['prerelease_title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_tests_release_3 = $mol_type_enforce<
		ReturnType< $shm_tests_release['stable_title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_tests_release_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tests_release_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_tests_release_6 = $mol_type_enforce<
		ReturnType< $shm_tests_release['release_meta'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_tests_release_7 = $mol_type_enforce<
		ReturnType< $shm_tests_release['release_notes'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_book2__pages_shm_tests_release_8 = $mol_type_enforce<
		ReturnType< $shm_tests_release['project_pages'] >
		,
		ReturnType< $mol_book2['pages'] >
	>
	type $mol_page__title_shm_tests_release_9 = $mol_type_enforce<
		ReturnType< $shm_tests_release['project_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_tests_release_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_shm_tests_release_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_tests_release_12 = $mol_type_enforce<
		ReturnType< $shm_tests_release['release_rows'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_tests_release_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_tests_release_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_tests_release extends $mol_book2_catalog {
		project_pages( id: any): readonly($mol_view)[]
		project_title( id: any): string
		project_info( id: any): string
		Project_info( id: any): $mol_text
		prerelease_title( id: any): string
		Prerelease( id: any): $mol_text
		stable_title( id: any): string
		Stable( id: any): $mol_text
		Channels( id: any): $mol_view
		release_rows( id: any): readonly($mol_view)[]
		release_title( id: any): string
		Release_title( id: any): $mol_view
		release_meta( id: any): string
		Release_meta( id: any): $mol_text
		release_notes( id: any): string
		Release_notes( id: any): $mol_text
		menu_title( ): string
		param( ): string
		menu_filter_enabled( ): boolean
		Project( id: any): $mol_book2
		Overview( id: any): $mol_page
		History( id: any): $mol_page
		Release( id: any): $mol_view
		Empty( ): $mol_paragraph
	}
	
}

//# sourceMappingURL=release.view.tree.d.ts.map